import { Selector } from '../../../zeus'

export const platformSelector = Selector('Platform')({
  id: true,
  name: true,
})
